import { useCallback } from 'react';
import { ProgramSummaryParams } from 'spw-redux/modules/program-summary/types';
import { actions as programSummaryActions } from 'spw-redux/modules/program-summary/actions';
import { useDispatch } from 'react-redux';

export const useProgramSummary = () => {
  const dispatch = useDispatch();

  const getSummaryData = useCallback(
    (params: ProgramSummaryParams) => {
      dispatch(programSummaryActions.getKeyData(params));
      dispatch(programSummaryActions.getUsfTotal(params));
      dispatch(programSummaryActions.getRsfTotal(params));
      dispatch(programSummaryActions.getWorkspaceBreakdown(params));
      dispatch(programSummaryActions.getSpacesBreakDown(params));
      dispatch(programSummaryActions.getAltWorkpointsBreakdown(params));
      dispatch(programSummaryActions.getSeatsOccupied(params));
      dispatch(programSummaryActions.getWorkplaceBehavior(params));
    },
    [dispatch]
  );
  return { getSummaryData };
};
